import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountHubSpotSite implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountHubSpotSiteContainer";
    }

    render() {
        // Forms are server rendered and submitted by the shared form handler (/account/hubspot/site/{link,settings,leadsync,disconnect}).
        // The page router drops URL hashes and only restores scroll offsets, so the setup checklist's "#hubspot-domains"
        // link (same page) is scrolled to here, both on click and on a direct page load with the hash.
        const scrollToDomains = () => document.getElementById("hubspot-domains")?.scrollIntoView();
        document.querySelectorAll<HTMLAnchorElement>("a[href$='#hubspot-domains']").forEach((a) => {
            a.addEventListener("click", (e) => {
                e.preventDefault();
                scrollToDomains();
            });
        });
        if (window.location.hash === "#hubspot-domains") {
            window.setTimeout(scrollToDomains, 0);
        }
    }
}
